import { Card, CardBody, Col } from "reactstrap";
import { H5, Image, SVG } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { YourBalance, YourTotalBalance } from "../../../../Constant";
import BalanceList from "./BalanceList";

const YourBalanceCard = () => {
  return (
    <Col xxl="3" md="6" xl="4" sm="12" className="box-col-6">
      <Card className={`balance-box  height-equal-2`}>
        <CardBody className="d-flex align-items-center justify-content-center">
          <div className="balance-profile">
            <div className="balance-img">
              <Image src={dynamicImage("dashboard/user.png")} alt="user vector"/>
              <Link to={`${process.env.PUBLIC_URL}/users/user-profile`} className="edit-icon"><SVG iconId="pencil" /></Link>
            </div>
            <span className="f-light d-block">{YourBalance}</span>
            <H5 className="mt-1">${YourTotalBalance}</H5>
            <BalanceList />            
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default YourBalanceCard;
